// extracted by mini-css-extract-plugin
module.exports = {"content":"newsPost-module--content--1p8M1","meta":"newsPost-module--meta--kv8o3","featured":"newsPost-module--featured--1J4px"};